<template>
  <v-chip
    class="map-button"
    color="bg-primary"
    text-color="primary"
    label
    @click="openMap"
  >
    <span class="text-body-1 font-weight-medium">На карте</span>
  </v-chip>
</template>

<script>
export default {
  name: 'MapButton',
  props: {
    mapUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    openMap() {
      window.open(this.mapUrl, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.map-button {
  &.v-chip {
    height: 40px;
    padding: 12px 24px;
    margin-right: 0;
  }
}
</style>
